// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pu-8";
export var editMode = "_pu-3";
export var headerRow = "_pu-a";
export var headerTitle = "_pu-b";
export var product = "_pu-1";
export var productDetails = "_pu-5";
export var productDivider = "_pu-7";
export var productImage = "_pu-2";
export var productInfo = "_pu-4";
export var productTitle = "_pu-6";
export var strikethrough = "_pu-9";
export var upsellProductsCard = "_pu-0";